/**
 * Debouncing function factory.
 * @param func - The function to run after the wait time is over.
 * @param wait - The number of ms to wait until the function is run.
 * @param immediate - Run the function immediately if true.
 */
export function debounce<T>(
  func: (...args: T[]) => void,
  wait: number,
  immediate: boolean = false
): (...args: T[]) => void {
  let timeout: number;

  return function (...args: T[]) {
    const later = () => {
      timeout = null;
      func.apply(this, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = window.setTimeout(later, wait);
    if (callNow) {
      func.apply(this, args);
    }
  };
}
